import type * as Core from "@zeller-public/payments-sdk-core";
import type { z } from "zod";

import type { PurchaseResponseSchema } from "../../terminal-purchase/schemas";
import type { RefundResponseSchema } from "../../terminal-refund/shared/schemas";

export function ProtocolErrorType_fromPosConnectorResponse(
	data: z.infer<typeof PurchaseResponseSchema>["data"] &
		z.infer<typeof RefundResponseSchema>["data"],
):
	| Exclude<
			Extract<
				Core.Protocol.Response,
				{ $type: "ResultError"; query?: "Terminal_purchase" }
			>["value"]["type"] &
				Extract<
					Core.Protocol.Response,
					{ $type: "ResultError"; query?: "Terminal_refund" }
				>["value"]["type"],
			"Setup Required"
	  >
	| undefined {
	const type = ErrorType_byResponseCode[data.responseCode];
	if (type) {
		return type;
	}

	if (type !== false && !data.responseCode.match(RE_UPSTREAM_ERROR)) {
		return "Transaction System Failure";
	}

	return undefined;
}

const RE_UPSTREAM_ERROR = /^\d{2}$/;

// https://npco-dev.atlassian.net/wiki/spaces/ARCH/pages/2641297411/Payment+App+-+SDK+response+code+and+response+text
const ErrorType_byResponseCode: Record<
	string,
	| NonNullable<ReturnType<typeof ProtocolErrorType_fromPosConnectorResponse>>
	| false
> = {
	// legacy P‑codes
	P2: "Card Read Failure",
	P3: "Cancelled",
	P4: "Cancelled",
	P5: "Inactivity Timeout",

	// new Q‑codes
	Q1: "Cancelled",
	Q2: "Inactivity Timeout",
	Q3: false,
	Q4: false,
	Q5: false,
	Q6: false,
	Q7: false,
	Q8: "Transaction Response Timeout",
	Q9: "Paired Device Busy",
	QA: "Transaction Response Invalid",
	QB: false,
	QC: "Transaction System Failure",
	QD: "Card Blocked",
	QE: "Card Not Supported",
	QF: "Card Read Failure",
	QG: "Card Insert Required",
	QH: "Transaction Declined",
	QI: "Transaction System Failure",
	QJ: "Transaction Network Failure",
};
